import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {
  baseUrl,
  getDBIMManualQuestionApi,
  getFrameWorkQuestionApi,
  getManualDataApi,
  getReportApi,
  liveRefApi,
  nicLoginApi,
  saveLogsApi,
} from "../helpers/Config";
import { clearAll, removeKeyData, storeData } from "../helpers/localStorage";
import { postToast } from "../helpers/CommonToast";
import dummyData from "../utils/dummy.json";

export const getManualData = createAsyncThunk(
  "manualData/getManualData",
  async (token, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${baseUrl}${getManualDataApi}`, {
        headers: {
          accept: "*/*",
          "Auth-Token": token,
        },
      });
      console.log("Manual Data is", response.data?.data);
      return response.data?.data;
    } catch (error) {
      console.log("Error occurred in manual data api", error);
      return rejectWithValue(error.message);
    }
  }
);

export const getDBIMManualData = createAsyncThunk(
  "manualData/getDBIMManualData",
  async ({ payload, token }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${baseUrl}${getDBIMManualQuestionApi}`,
        payload,
        {
          headers: {
            accept: "*/*",
            "Auth-Token": token,
          },
        }
      );
      console.log("DBIMS Manual Data is", response.data?.data);
      return response.data?.data;
    } catch (error) {
      console.log("Error occurred in dbim manual data api", error);
      return rejectWithValue(error.message);
    }
  }
);

export const getOverallData = createAsyncThunk(
  "overAllData",
  async ({ apiUrl, token }, { rejectWithValue }) => {
    try {
      const response = await axios.get(apiUrl, {
        headers: {
          accept: "*/*",
          "Auth-Token": token,
        },
      });
      console.log("Overall Data is", response.data?.data);
      return response.data?.data;
    } catch (error) {
      console.log("Error occurred in overall data api", error);
      return rejectWithValue(error.message);
    }
  }
);

export const getDBIMOverallData = createAsyncThunk(
  "getDBIMOverallData",
  async ({ apiUrl, token }, { rejectWithValue }) => {
    try {
      const response = await axios.get(apiUrl, {
        headers: {
          accept: "*/*",
          "Auth-Token": token,
        },
      });
      console.log("Overall Data is", response.data?.data);
      return response.data?.data;
    } catch (error) {
      console.log("Error occurred in overall data api", error);
      return rejectWithValue(error.message);
    }
  }
);

export const siteDashData = createAsyncThunk(
  "initialDashData/siteDashData",
  async ({ apiUrl, token }, { rejectWithValue }) => {
    console.log("token", token);
    try {
      const response = await axios.get(apiUrl, {
        headers: {
          accept: "*/*",
          "Auth-Token": token,
        },
      });
      console.log("REDUX Dash Data is", response.data);
      if (!response.data.status) {
        return { data: dummyData, errorMessage: response.data.error };
      }
      return { data: response.data, errorMessage: response.data.error };
    } catch (error) {
      console.log("Error of dash Data ", error?.message);
      return rejectWithValue(error.message);
    }
  }
);

export const refreshApi = createAsyncThunk(
  `refresh/fetch`,
  async ({ refreshType, token, actualSlug }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${baseUrl}${liveRefApi}`,
        refreshType,
        {
          headers: {
            accept: "*/*",
            "Auth-Token": token,
          },
        }
      );
      console.log("Live Reporting(Redux)", response.data);
      return { slug: actualSlug, data: response?.data };
    } catch (error) {
      console.log("Error in live reporting data", error);
      return rejectWithValue({ slug: actualSlug, error: error?.message });
    }
  }
);

export const requestApi = createAsyncThunk(
  `request/fetch`,
  async ({ reqPayload, token, actualSlug }, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${baseUrl}${liveRefApi}`, reqPayload, {
        headers: {
          accept: "*/*",
          "Auth-Token": token,
        },
      });
      console.log("Live REQUESTING(Redux)", response.data);
      return { slug: actualSlug, data: response?.data };
    } catch (error) {
      console.log("Error in live requestiing data", error);
      return rejectWithValue({ slug: actualSlug, error: error?.message });
    }
  }
);

export const reportAnswerApi = createAsyncThunk(
  `reportAnswer`,
  async ({ apiUrl, payloadData, token }, { rejectWithValue }) => {
    try {
      const response = await axios.post(apiUrl, payloadData, token);
      console.log("Website Response data is(redux)", response?.data);
      return response?.data;
    } catch (error) {
      console.log("Error occured in getting website report", error);
      return rejectWithValue(error);
    }
  }
);

export const nicLogin = createAsyncThunk(
  `nic/login`,
  async (field, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${baseUrl}${nicLoginApi}`, field, {});
      console.log("Response data", response.data);
      if (response?.data?.data?.user_id && response?.data?.data?.authToken) {
        const currentTime = new Date().getTime();
        storeData("frontend_loginTime", `${currentTime}`);
        storeData("nic_front_authToken", response?.data?.data?.authToken);
        storeData("nic_front_userId", response?.data?.data?.user_id);
        storeData("nic_login_data", response?.data?.data);
        storeData("nic_front_userName", response?.data?.data?.name);
        const isManualUser = response?.data?.data?.ismanual;
        storeData("isManualUser", isManualUser ? isManualUser : false);
      } else {
        postToast(
          `Error occured while loging in. Please try again after sometime.`,
          `error`
        );
      }
      return response?.data;
    } catch (error) {
      console.log("Error in sign in", error);
      return rejectWithValue(error);
    }
  }
);

export const postLog = createAsyncThunk(
  `login/postLog`,
  async ({ userId, token, action }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${baseUrl}${saveLogsApi}`,
        {
          action: action,
          url: "url",
          user_id: userId,
        },
        {
          headers: {
            accept: "*/*",
            "Auth-Token": `${token}`,
          },
        }
      );
      removeKeyData(`prev_Report`);
      console.log("Data for Logs", response.data);
      return response?.data;
    } catch (error) {
      console.log("Error occured in posting logs", error);
      return rejectWithValue(error);
    }
  }
);

export const getUserSiteApi = createAsyncThunk(
  `getSites`,
  async ({ apiUrl, token }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        apiUrl,
        {},
        {
          headers: {
            accept: "*/*",
            "Auth-Token": `${token}`,
          },
        }
      );
      localStorage.setItem("user_site_details", JSON.stringify(response.data));
      console.log("Response for Get Sites ", response.data);
      return response?.data;
    } catch (error) {
      console.log("Error in getting sites", error);
      return rejectWithValue(error?.message);
    }
  }
);

export const fetchReportData = createAsyncThunk(
  `excelReportSlice`,
  async ({ apiUrl, token }, { rejectWithValue }) => {
    try {
      const response = await axios.get(apiUrl, {
        headers: {
          accept: "*/*",
          "Auth-Token": `${token}`,
        },
      });
      console.log("Reponse for get excel report", response.data);
      return response?.data;
    } catch (error) {
      console.log("Error occured while generating excel report", error);
      return rejectWithValue(error?.message);
    }
  }
);

export const fetchAdvancedReportData = createAsyncThunk(
  `fetchAdvancedReportData`,
  async ({ apiUrl, token }, { rejectWithValue }) => {
    try {
      const response = await axios.get(apiUrl, {
        headers: {
          accept: "*/*",
          "Auth-Token": `${token}`,
        },
      });
      console.log("Reponse for getting advanced excel report", response.data);
      return response?.data;
    } catch (error) {
      console.log(
        "Error occured while generating advanced excel report",
        error
      );
      return rejectWithValue(error?.message);
    }
  }
);

export const frameWorkQuestionApi = createAsyncThunk(
  `framework`,
  async ({ token }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${getReportApi}${getFrameWorkQuestionApi}`,
        {
          headers: {
            accept: "*/*",
            "Auth-Token": `${token}`,
          },
        }
      );
      console.log(
        "FrameWork Response is",
        response?.data?.data?.questions?.data
      );
      return response?.data;
    } catch (error) {
      console.log("Error occured in fetching the frameWork", error);
      return rejectWithValue(error);
    }
  }
);

export const dbimsDataApi = createAsyncThunk(
  `dbimsData`,
  async ({ apiUrl, token }, { rejectWithValue }) => {
    try {
      const response = await axios.get(apiUrl, {
        headers: {
          accept: "*/*",
          "Auth-Token": token,
        },
      });
      console.log("Dbims data is", response.data);
      return response.data;
    } catch (error) {
      console.log("Error occured in dbims data ", error?.message);
      return rejectWithValue(error.message);
    }
  }
);

export const loginApi = createAsyncThunk(
  `loginApi`,
  async ({ apiUrl, field, loadCaptcha, loginField }, { rejectWithValue }) => {
    try {
      const response = await axios.post(apiUrl, field);
      if (response?.data?.data?.user_id && response?.data?.data?.authToken) {
        const currentTime = new Date().getTime();
        storeData("frontend_loginTime", `${currentTime}`);
        storeData("nic_front_authToken", response?.data?.data?.authToken);
        storeData("nic_front_userId", response?.data?.data?.user_id);
        const isManualUser = response?.data?.data?.ismanual;
        storeData("isManualUser", isManualUser ? isManualUser : false);
        storeData("nic_front_userName", response?.data?.data?.name);
      } else {
        postToast(
          `${response?.data?.error}`,
          `error`
        );
        loginField.captcha = "";
        loadCaptcha();
      }
      storeData("nic_user_details", JSON.stringify(response?.data));
      console.log("User logged in", response?.data);
      return response?.data;
    } catch (error) {
      console.log("Error occured while logging in", error);
      if (
        error.response.data.message ===
        "User already logged in on another device. Please logout first."
      ) {
        postToast(error.response.data.message, `error`);
      } else {
        postToast(
          `Error occured while loging in. Please try again after sometime.`,
          `error`
        );
      }

      return rejectWithValue(error);
    }
  }
);

export const parichayLoginUrl = createAsyncThunk(
  `parichayLoginUrl`,
  async ({ apiUrl }, { rejectWithValue }) => {
    try {
      const response = await axios.get(apiUrl);
      return response?.data;
    } catch (error) {
      console.log("Error occured in fetching parichay login url", error);
      return rejectWithValue(error);
    }
  }
);

export const logoutApiAction = createAsyncThunk(
  `logoutApiAction`,
  async ({ apiUrl, field, token }, { rejectWithValue }) => {
    try {
      const response = await axios.post(apiUrl, field, {
        headers: {
          accept: "*/*",
          "Auth-Token": token,
        },
      });
      await clearAll();
      return response?.data;
    } catch (error) {
      console.log("Error occured in logging user out.", error);
      return rejectWithValue(error);
    }
  }
);

export const saveManualDataApi = createAsyncThunk(
  `saveManualDataApi`,
  async ({ apiUrl, manualRecord, token }, { rejectWithValue }) => {
    try {
      const response = await axios.post(apiUrl, manualRecord, {
        headers: {
          accept: "*/*",
          "Auth-Token": `${token}`,
        },
      });
      postToast("Your survey has been filled.", "success");
      return response?.data;
    } catch (error) {
      console.log("Error occured while adding your response.", error);
      postToast("Error occured while filling survey.", "error");
      rejectWithValue(error);
    }
  }
);

export const saveDBIMManualDataApi = createAsyncThunk(
  `saveDBIMManualDataApi`,
  async ({ apiUrl, dbim_manualRecord, token }, { rejectWithValue }) => {
    try {
      const response = await axios.post(apiUrl, dbim_manualRecord, {
        headers: {
          accept: "*/*",
          "Auth-Token": `${token}`,
        },
      });
      postToast("Your DBIM survey has been filled.", "success");
      return response?.data;
    } catch (error) {
      console.log("Error occured while adding your response.", error);
      postToast("Error occured while filling survey.", "error");
      rejectWithValue(error);
    }
  }
);

export const parichayLogoutApi = createAsyncThunk(
  `parichayLogoutApi`,
  async ({ apiUrl, token }, { rejectWithValue }) => {
    try {
      const response = await axios.post(apiUrl, {
        headers: {
          accept: "*/*",
          "Auth-Token": `${token}`,
        },
      });
      console.log("Sucessfully logged out from parichay", response?.data);
      return response?.data;
    } catch (error) {
      console.log("Error occured while logging out from parichay.", error);
      rejectWithValue(error);
    }
  }
);

export const checkParichayAuthenticityApi = createAsyncThunk(
  `checkParichayAuthenticityApi`,
  async ({ apiUrl, token }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        apiUrl,
        {},
        {
          headers: {
            accept: "*/*",
            "Auth-Token": `${token}`,
          },
        }
      );
      console.log("User logged out from parichay portal", response?.data);
      return response?.data;
    } catch (error) {
      console.log("Error occured while checking parichay authenticity.", error);
      rejectWithValue(error);
    }
  }
);

export const checkAuthenticityApi = createAsyncThunk(
  `checkAuthenticityApi`,
  async ({ apiUrl, token }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        apiUrl,
        {},
        {
          headers: {
            accept: "*/*",
            "Auth-Token": `${token}`,
          },
        }
      );
      console.log("User authentication response.", response?.data);
      return response?.data;
    } catch (error) {
      console.log("Error occured in checking authenticity.", error);
      rejectWithValue(error);
    }
  }
);

export const getDbimSurveyAnswers = createAsyncThunk(
  `getDbimSurveyQuestions`,
  async ({ apiUrl, payloadData, token }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        apiUrl,

        payloadData,
        {
          headers: {
            accept: "*/*",
            "Auth-Token": `${token}`,
          },
        }
      );
      console.log("Dbim survey question response.", response?.data);
    } catch (error) {
      console.log("Error occured in getting dbim survey questions.", error);
      rejectWithValue(error);
    }
  }
);

export const checkLiveReportStatus = createAsyncThunk(
  `checkLiveReportStatus`,
  async ({ apiUrl, token, actualSlug }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        apiUrl,
        {},
        {
          headers: {
            accept: "*/*",
            "Auth-Token": `${token}`,
          },
        }
      );
      return { slug: actualSlug, data: response?.data };
    } catch (error) {
      return rejectWithValue({ slug: actualSlug, error: error?.message });
    }
  }
);
export const checkisReportAlreadyGenerating = createAsyncThunk(
  `checkisReportAlreadyGenerating`,
  async ({ apiUrl, token }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        apiUrl,
        {},
        {
          headers: {
            accept: "*/*",
            "Auth-Token": `${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const checkParichayToken = createAsyncThunk(
  `checkParichayToken`,
  async ({ apiUrl, token }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        apiUrl,
        {},
        {
          headers: {
            accept: "*/*",
            "Auth-Token": `${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// export const
